import { render } from "./flagheader.vue?vue&type=template&id=696958d0"
import script from "./flagheader.vue?vue&type=script&lang=js"
export * from "./flagheader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__